<template>
  <div v-if="!loading">
    <ul class="menuList bor-btm">
      <li @click.stop="selectFolder({ type: 'all_sequence' })">
        <i class="w-10 material-icons">folder_open</i>
        <span class="w-80 text">My Sequences</span>
        <i class="w-10 material-icons">keyboard_arrow_right</i>
      </li>
      <li class="shared-foler" @click.stop="selectFolder({ type: 'shared' })">
        <i class="w-10 material-icons">folder_open</i>
        <i class="material-icons shared-icon-arrow">reply</i>
        <span class="w-80 text">Shared Sequences</span>
        <i class="w-10 material-icons">keyboard_arrow_right</i>
      </li>
      <li
        v-for="(ele, index) in folderList"
        :key="index"
        @click.stop="selectFolder(ele)"
      >
        <i class="w-10 material-icons">folder_open</i>
        <span class="w-80 text">{{ ele.folderName }}</span>
        <i class="w-10 material-icons">keyboard_arrow_right</i>
      </li>
    </ul>
  </div>
  <div v-else class="menu-load-list">
    <ul class="menuList d-content">
      <li v-for="index in 5" :key="index">
        <span class="w-10 m-r-10 linear-background"></span>
        <span class="w-80 m-r-10 text linear-background"></span>
        <span class="w-10 linear-background"></span>
      </li>
    </ul>
  </div>
</template>

<script>
// import { postFromCustomUrl } from './../assets/util/rest.js'
// import shareFunction from './../assets/util/functions.js'
// import { MxEvent } from './../assets/util/constants/analytics.js'

export default {
  name: 'SequenceFolder',
  props: ['folderList', 'loading'],
  data: function() {
    return {}
  },
  components: {},
  methods: {
    selectFolder(obj) {
      this.$emit('selectedFolder', obj)
    }
  }
}
</script>

<style lang="scss" scoped>
.menuList {
  @include relBlock;
  margin: 10px 5px !important;
  li {
    @include relBlock;
    color: $text-dark;
    &:not(:last-child) {
      border-bottom: 1px solid $bg-medium;
    }
    i {
      font-size: 20px;
      &.shared-icon-arrow {
        font-size: 14px !important;
        left: 17px !important;
        bottom: 6px !important;
        border-radius: 50%;
      }
    }
  }
  .shared-foler:hover {
    .shared-icon-arrow {
      background: rgb(235, 243, 248) !important;
    }
  }
}
.menu-load-list {
  @include relBlock;
  .menuList.d-content {
    @include relBlock;
    .m-r-10 {
      margin-right: 10px;
    }
    li {
      padding: 7px 10px !important;
      .linear-background {
        border-radius: 6px;
        height: 16px;
      }
      .m-r-10 {
        margin-right: 10px;
      }
      &:hover {
        background: transparent !important;
      }
    }
  }
}
.shared-icon-arrow {
  position: absolute;
  font-size: 14px;
  left: 23px;
  bottom: 12px;
  transform: scale(-1, 1);
  background: #fff;
  padding: 0px 2px;
}
</style>
